import React from 'react'
import PropTypes from 'prop-types';
import PageContainer from '../../layout/PageContainer';
import ProduccionMensualGarantia from './ProduccionMensualGarantia';


const ProduccionMensualGarantiaContainer = ({ history }) => (
  <PageContainer
    breadcrumbs={[
      { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
      { id: 1, name: 'CORREDOR', url: '/corredor/polizas-garantia' },
      { id: 2, name: 'PRODUCCIÓN MENSUAL GARANTÍA' },
    ]}
    clientFilter={{
      type: 'corredor',
      ramo: 'garantia',
      showFilter: true,
    }}
  >
    {(corredor) => (
      <ProduccionMensualGarantia corredor={corredor} history={history} />
    )}
  </PageContainer>
);

ProduccionMensualGarantiaContainer.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

export default ProduccionMensualGarantiaContainer;
